import { Content } from 'src/app/models/content.model';

export const TOOLS_CONTENT: Content = new Content({
   idContent: 'ed50542c6ca94fc909e8391bd59c69fc',
   order: 1,
   title: 'Herramientas de apoyo',
   content: `
   <div class="row">
      <div class="col-6 mx-auto">
         <app-button-url
            [url]="'http://www.gob.mx/cms/uploads/attachment/file/55132/1.1_Ejemplo_de_pol_tica_de_igualdad_laboral_y_no_discriminaci_n_.pdf'"
            [title]="'Política de igualdad laboral y no discriminación'"
            [icon]="'description'">
         </app-button-url>
      </div>
   </div>
   `,
   subContents: [
   ]
});